import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Button,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Menu,
  MenuItem,
} from '@mui/material';
import { FaCut } from 'react-icons/fa';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import PoolIcon from '@mui/icons-material/Pool';
import CurrencyBitcoinIcon from '@mui/icons-material/CurrencyBitcoin';
import BlockIcon from '@mui/icons-material/ViewModule';
import MinerIcon from '@mui/icons-material/Engineering';
import ExchangeIcon from '@mui/icons-material/SwapHoriz';
import PersonIcon from '@mui/icons-material/Person';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { styled } from '@mui/system';
import { AuthContext } from '../AuthContext';

const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  &:hover {
    color: #fff;
  }
`;

function Navbar() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [anchorElCoins, setAnchorElCoins] = useState(null); // Para el menú Coins
  const [anchorEl, setAnchorEl] = useState(null); // Para el menú de usuario
  const { user, setUser } = useContext(AuthContext);
  const isAuthenticated = !!user;
  const navigate = useNavigate();

  const toggleNavbar = () => setIsCollapsed((prev) => !prev);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
    navigate('/login');
  };

  const handleCoinsMenuOpen = (event) => {
    setAnchorElCoins(event.currentTarget);
  };

  const handleCoinsMenuClose = () => {
    setAnchorElCoins(null);
  };

  const handleUserMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: '#1b303f' }}>
        <Toolbar>
          <Box component="img" src="/img/logo.webp" alt="Logo" sx={{ height: 40, mr: 2 }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <StyledLink to="/">CoinStatsHub.tech Beta</StyledLink>
          </Typography>
          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            <Button color="inherit" component={StyledLink} to="/">
              <HomeIcon /> Home
            </Button>
            <Button color="inherit" component={StyledLink} to="/pools">
              <PoolIcon /> Pools
            </Button>
            {/* Coins Menu */}
            <Button
              color="inherit"
              endIcon={<ArrowDropDownIcon />}
              onClick={handleCoinsMenuOpen}
            >
              <CurrencyBitcoinIcon /> Coins
            </Button>
            <Menu
              anchorEl={anchorElCoins}
              open={Boolean(anchorElCoins)}
              onClose={handleCoinsMenuClose}
            >
              <MenuItem
                component={StyledLink}
                to="/coins"
                onClick={handleCoinsMenuClose}
              >
                Coins
              </MenuItem>
              <MenuItem
                component={StyledLink}
                to="/NewCoins"
                onClick={handleCoinsMenuClose}
              >
                New Coins
              </MenuItem>
              <MenuItem
                component={StyledLink}
                to="/latestreleases"
                onClick={handleCoinsMenuClose}
              >
                Latest Releases
              </MenuItem>
            </Menu>
            <Button color="inherit" component={StyledLink} to="/WalletSearch">
              <CurrencyBitcoinIcon /> Wallet
            </Button>
            <Button color="inherit" component={StyledLink} to="/blocks">
              <BlockIcon /> Blocks
            </Button>
            <Button color="inherit" component={StyledLink} to="/CurrencyEvents">
              <FaCut style={{ marginRight: '8px' }} />
              Halving
            </Button>
            <Button color="inherit" component={StyledLink} to="/algorithmhardware">
              <MinerIcon /> Algorithm hardware
            </Button>
            <Button color="inherit" component={StyledLink} to="/intercambios">
              <ExchangeIcon /> Exchanges
            </Button>

            {isAuthenticated ? (
              <>
                <Button
                  color="inherit"
                  endIcon={<ArrowDropDownIcon />}
                  onClick={handleUserMenuOpen}
                >
                  <PersonIcon /> {user.username}
                </Button>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleUserMenuClose}
                >
                  <MenuItem
                    component={StyledLink}
                    to="/user/profile"
                    onClick={handleUserMenuClose}
                  >
                    <PersonIcon sx={{ marginRight: '8px' }} />
                    Profile
                  </MenuItem>
                  <MenuItem
                    component={StyledLink}
                    to="/dashboard"
                    onClick={handleUserMenuClose}
                  >
                    <DashboardIcon sx={{ marginRight: '8px' }} />
                    Dashboard
                  </MenuItem>
                  <MenuItem onClick={handleLogout}>
                    Logout
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <>
                <Button color="inherit" component={StyledLink} to="/register">
                  Register
                </Button>
                <Button color="inherit" component={StyledLink} to="/login">
                  Login
                </Button>
              </>
            )}
          </Box>
          <IconButton
            edge="end"
            color="inherit"
            aria-label="menu"
            onClick={toggleNavbar}
            sx={{ display: { xs: 'block', md: 'none' } }}
            aria-controls="navbar-drawer"
            aria-expanded={isCollapsed}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer id="navbar-drawer" anchor="right" open={isCollapsed} onClose={toggleNavbar}>
        <List>
          <ListItem button component={StyledLink} to="/" onClick={toggleNavbar}>
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary="Home" />
          </ListItem>
          <ListItem button component={StyledLink} to="/pools" onClick={toggleNavbar}>
            <ListItemIcon>
              <PoolIcon />
            </ListItemIcon>
            <ListItemText primary="Pools" />
          </ListItem>
          {/* Coins Menu */}
          <ListItem button component={StyledLink} to="/coins" onClick={toggleNavbar}>
            <ListItemIcon>
              <CurrencyBitcoinIcon />
            </ListItemIcon>
            <ListItemText primary="Coins" />
          </ListItem>
          <ListItem button component={StyledLink} to="/NewCoins" onClick={toggleNavbar}>
            <ListItemIcon>
              <CurrencyBitcoinIcon />
            </ListItemIcon>
            <ListItemText primary="New Coins" />
          </ListItem>
          <ListItem button component={StyledLink} to="/latestreleases" onClick={toggleNavbar}>
            <ListItemIcon>
              <CurrencyBitcoinIcon />
            </ListItemIcon>
            <ListItemText primary="Latest Releases" />
          </ListItem>
          <ListItem button component={StyledLink} to="/WalletSearch" onClick={toggleNavbar}>
            <ListItemIcon>
              <CurrencyBitcoinIcon />
            </ListItemIcon>
            <ListItemText primary="WalletSearch" />
          </ListItem>
          <ListItem button component={StyledLink} to="/blocks" onClick={toggleNavbar}>
            <ListItemIcon>
              <BlockIcon />
            </ListItemIcon>
            <ListItemText primary="Blocks" />
          </ListItem>
          <ListItem button component={StyledLink} to="/algorithmhardware" onClick={toggleNavbar}>
            <ListItemIcon>
              <MinerIcon />
            </ListItemIcon>
            <ListItemText primary="Algorithm hardware" />
          </ListItem>
          <ListItem button component={StyledLink} to="/intercambios" onClick={toggleNavbar}>
            <ListItemIcon>
              <ExchangeIcon />
            </ListItemIcon>
            <ListItemText primary="Exchanges" />
          </ListItem>
          {isAuthenticated ? (
            <>
              <ListItem button component={StyledLink} to="/user/profile" onClick={toggleNavbar}>
                <ListItemIcon>
                  <PersonIcon />
                </ListItemIcon>
                <ListItemText primary="Profile" />
              </ListItem>
              <ListItem button component={StyledLink} to="/dashboard" onClick={toggleNavbar}>
                <ListItemIcon>
                  <DashboardIcon />
                </ListItemIcon>
                <ListItemText primary="Dashboard" />
              </ListItem>
              <ListItem button onClick={handleLogout}>
                <ListItemText primary="Logout" />
              </ListItem>
            </>
          ) : (
            <>
              <ListItem button component={StyledLink} to="/register" onClick={toggleNavbar}>
                <ListItemText primary="Register" />
              </ListItem>
              <ListItem button component={StyledLink} to="/login" onClick={toggleNavbar}>
                <ListItemText primary="Login" />
              </ListItem>
            </>
          )}
        </List>
      </Drawer>
    </>
  );
}

export default Navbar;
